export default __webpack_public_path__ + "static/media/contentful.865752fa.svg";